const confirmedEmail = ref('')

export { confirmedEmail }
